import { requete } from '../api/client';
import type { Emplacement } from '../pages/marches/types';
import { ouvrirBase } from './stockage';

export type PlaceEmportee = Pick<
  Emplacement,
  | 'id'
  | 'reference'
  | 'marche_id'
  | 'position'
  | 'precision'
  | 'position_version'
  | 'attribution_en_cours'
>;
export const CLE_PLACES = 'places-marches';

export async function placesEmportees(): Promise<PlaceEmportee[]> {
  const toutes = (await (await ouvrirBase()).get('meta', CLE_PLACES)) as
    Record<string, PlaceEmportee> | undefined;
  return Object.values(toutes ?? {}).sort((a, b) => a.reference.localeCompare(b.reference));
}

export async function memoriserPlace(place: PlaceEmportee): Promise<void> {
  const b = await ouvrirBase();
  const tx = b.transaction('meta', 'readwrite');
  const toutes = (await tx.store.get(CLE_PLACES)) as Record<string, PlaceEmportee> | undefined;
  await tx.store.put({ ...toutes, [place.id]: place }, CLE_PLACES);
  await tx.done;
}

export async function telechargerPlace(id: string): Promise<PlaceEmportee> {
  const e = await requete<Emplacement>(`/marches/emplacements/${id}`);
  const place: PlaceEmportee = {
    id: e.id,
    reference: e.reference,
    marche_id: e.marche_id,
    position: e.position,
    precision: e.precision,
    position_version: e.position_version,
    attribution_en_cours: e.attribution_en_cours,
  };
  await memoriserPlace(place);
  return place;
}
